// Infinite logo row: duplicates the list once so the track can scroll by -50% and loop seamlessly.
// Markup: [data-marquee] > .track > ul(list). Speed is in px per second (data-marquee-speed, default 40).
export default function marquee() {
  document.querySelectorAll('[data-marquee]').forEach((root) => {
    const track = root.firstElementChild;
    const list = track && track.firstElementChild;
    if (!list) return;

    const clone = list.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('img').forEach((img) => img.setAttribute('alt', ''));
    track.appendChild(clone);

    const speed = Number(root.dataset.marqueeSpeed) || 40;
    const setDuration = () => {
      root.style.setProperty('--marquee-duration', `${list.scrollWidth / speed}s`);
    };

    setDuration();
    window.addEventListener('load', setDuration);
  });
}
